import { dyeColors, makeStyles, ModeOptions } from '~styles';

export const useStyles = makeStyles<void, 'label'>()((theme, _params, classes) => {
	const { palette, mode } = theme;
	const { label } = classes;

	return {
		toggle: {
			boxSizing: 'border-box',
			cursor: 'pointer',
			display: 'inline-flex',
			outline: mode === ModeOptions.Dye ? `1px solid ${dyeColors.main}` : undefined,
			position: 'relative',
			':has(> input:disabled)': {
				cursor: 'default',
			},
		},
		input: {
			height: ' 1px',
			opacity: 0,
			position: 'absolute',
			width: '1px',
			[`&:checked + .${label}`]: {
				backgroundColor: mode === ModeOptions.Dye ? dyeColors.main : palette.primary.main,
				boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.05)',
				'&:before': {
					left: '16px',
				},
			},
		},
		label: {
			backgroundColor: mode === ModeOptions.Dye ? dyeColors.lighter : palette.gray[500],
			border: 'none',
			borderRadius: '25px',
			height: '20px',
			width: '40px',
			// rounded handle
			'&:before': {
				content:
					'url("data:image/png;base64,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")',
				height: '16px',
				left: '-4px',
				top: '-4px',
				opacity: 1,
				position: 'absolute',
				zIndex: 1,
				transition: 'left 200ms cubic-bezier(0.25, 0.1, 0.25, 1)',
			},
		},
	};
});
